import type { Auth0ProviderOptions } from '@auth0/auth0-react'

const getRedirectUri = (): string => {
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/login/callback`
  }
  return '/login/callback'
}

const auth0Config: Auth0ProviderOptions = {
  domain: import.meta.env['VITE_AUTH0_DOMAIN'],
  clientId: import.meta.env['VITE_AUTH0_CLIENT_ID'],
  authorizationParams: {
    redirect_uri: getRedirectUri(),
    response_type: 'code',
    scope: 'openid profile email offline_access',
    audience: import.meta.env['VITE_AUTH0_AUDIENCE'],
  },
  useRefreshTokens: true,
  cacheLocation: 'localstorage',
}

export default auth0Config
